<template>
  <footer class="footer" ref="footerRef" :class="{ 'animate-in': isVisible }">
    <div class="footer-content">
      <div class="footer-columns">
        <!-- Column 1: 关于瑞和云图 -->
        <div class="footer-column">
          <div class="column-title" :class="{ 'accordion-open': openAccordion === 0 }" @click="toggleAccordion(0)">关于瑞和云图</div>
          <ul class="column-list" :class="{ 'accordion-open': openAccordion === 0 }">
            <li><router-link to="/about-us">了解瑞和云图</router-link></li>
            <li><router-link to="/#success-cases">成功案例</router-link></li>
            <li><router-link to="/contact-us">联系我们</router-link></li>
          </ul>
        </div>

        <!-- Column 2: 热门产品 -->
        <div class="footer-column">
          <div class="column-title" :class="{ 'accordion-open': openAccordion === 1 }" @click="toggleAccordion(1)">热门产品</div>
          <ul class="column-list" :class="{ 'accordion-open': openAccordion === 1 }">
            <li><router-link to="/product/cloud-security-resource-pool">云安全资源池</router-link></li>
            <li><router-link to="/product/sslo">流量编排器</router-link></li>
            <li><router-link to="/product/edge-cloud/cloud-host">智算云</router-link></li>
            <li><router-link to="/product/ai-token-gateway">AI Token 网关</router-link></li>
            <li><router-link to="/product/ai-computing-platform">AI 推理平台</router-link></li>
            <li><router-link to="/product/ai-native-platform">AI native 平台</router-link></li>
            <li><router-link to="/product/ai-agent-application">AI 场景智能应用</router-link></li>
            <li><router-link to="/product/hyper-converged-cloud">AI SOC</router-link></li>
            <li><router-link to="/product/equal-protection-appliance">等保一体机</router-link></li>
          </ul>
        </div>

        <!-- Column 3: 解决方案 -->
        <div class="footer-column">
          <div class="column-title" :class="{ 'accordion-open': openAccordion === 2 }" @click="toggleAccordion(2)">解决方案</div>
          <ul class="column-list" :class="{ 'accordion-open': openAccordion === 2 }">
            <li><router-link to="/solutions/ai-platform">AI 算力平台解决方案</router-link></li>
            <li><router-link to="/solutions/sase">SASE安全运营解决方案</router-link></li>
            <li><router-link to="#">云安全资源池解决方案</router-link></li>
            <li><router-link to="/solutions/equal-protection">中小系统低成本安全解决方案</router-link></li>
            <li><router-link to="/solutions/dedicated-line-security">运营商安全解决方案</router-link></li>
            <li><router-link to="/solutions/zwy">行业云/政务云安全解决方案</router-link></li>
          </ul>
        </div>

        <!-- Column 4: 如何购买 / 联系方式 -->
        <div class="footer-column contact-column">
          <div class="column-title" :class="{ 'accordion-open': openAccordion === 4 }" @click="toggleAccordion(4)">如何购买</div>
          <div class="buy-block" :class="{ 'accordion-open': openAccordion === 4 }">
            <div class="pc-contact">
              <div class="qr-text">售前咨询</div>
              <div class="contact-phone">010–84109606</div>
            </div>
            <div class="pc-contact">
              <div class="qr-text">售后服务</div>
              <div class="contact-phone">010–84109606</div>
            </div>
          </div>
          <div class="column-title column-title-follow" :class="{ 'accordion-open': openAccordion === 5 }" @click="toggleAccordion(5)">关注瑞和云图</div>
          <div class="qr-code" :class="{ 'accordion-open': openAccordion === 5 }">
            <img src="@/assets/ewm.svg" alt="公众号">
          </div>
        </div>
      </div>

      <div class="mobile-contact">
        <div class="qr-text">售前咨询热线</div>
        <div class="contact-phone">010–84109606</div>
      </div>

      <div class="separator-line"></div>

      <!-- 版权与备案 -->
      <div class="copyright">
        <p class="copyright-text">© Copyright 2026 北京瑞和云图科技有限公司 &nbsp;|&nbsp; 京ICP备16045821号</p>
        <!-- <p class="copyright-links">
          <router-link to="#">个人信息保护及隐私政策</router-link>
          <span class="dot">|</span>
          <router-link to="#">用户服务协议</router-link>
        </p> -->
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      openAccordion: null, // 当前打开的手风琴项，null表示没有打开的项
      isAnimating: false, // 防止动画期间重复点击
      isVisible: false, // 是否进入视口
      observer: null // IntersectionObserver 实例
    }
  },
  methods: {
    toggleAccordion(index) {
      // 只在移动端执行手风琴逻辑
      if (window.innerWidth <= 768 && !this.isAnimating) {
        this.isAnimating = true;
        
        // 使用requestAnimationFrame确保动画流畅
        requestAnimationFrame(() => {
          // 如果点击的是当前已打开的项，则关闭它
          if (this.openAccordion === index) {
            this.openAccordion = null;
          } else {
            // 否则打开点击的项
            this.openAccordion = index;
          }
          
          // 动画完成后重置标志
          setTimeout(() => {
            this.isAnimating = false;
          }, 200);
        });
      }
    },
    initObserver() {
      // 创建 IntersectionObserver 监听 footer 进入视口
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isVisible) {
              this.isVisible = true;
              // 动画触发后断开观察，避免重复触发
              this.observer.disconnect();
            }
          });
        },
        {
          threshold: 0.1, // 当 10% 进入视口时触发
          rootMargin: '0px 0px -50px 0px' // 提前 50px 触发
        }
      );
      
      if (this.$refs.footerRef) {
        this.observer.observe(this.$refs.footerRef);
      }
    }
  },
  mounted() {
    // 监听窗口大小变化，在PC端重置手风琴状态
    window.addEventListener('resize', () => {
      if (window.innerWidth > 768) {
        this.openAccordion = null;
      }
    });
    
    // 初始化进入视口动画观察器
    this.$nextTick(() => {
      this.initObserver();
    });
  },
  beforeUnmount() {
    // 清理观察器
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
</script>

<style scoped>
/* ===== 主底部浅色区 ===== */
.footer {
  background:
    radial-gradient(circle at 18% 0%, rgba(147, 197, 253, 0.45), transparent 28%),
    radial-gradient(circle at 88% 8%, rgba(186, 230, 253, 0.4), transparent 24%),
    linear-gradient(180deg, #e8f1ff 0%, #dbeafe 55%, #eef5ff 100%);
  width: 100%;
  padding: 56px 0 0;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px 40px;
  position: relative;
}

.footer-columns {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 48px 32px;
  margin-bottom: 40px;
}

.footer-column {
  text-align: left;
}

.contact-column {
  display: flex;
  flex-direction: column;
}

.column-title {
  color: #0f172a;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  line-height: 1.4;
  letter-spacing: 0.02em;
}

.column-title-follow {
  margin-top: 24px;
}

.column-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.column-list li {
  margin-bottom: 12px;
}

.column-list a {
  color: #475569;
  text-decoration: none;
  font-size: 14px;
  line-height: 1.7;
  transition: color 0.2s ease;
  font-weight: 400;
}

.column-list a:hover {
  color: #1d4ed8;
}

/* 如何购买区块 */
.buy-block {
  display: block;
}

.pc-contact {
  margin-bottom: 16px;
}

.qr-text {
  color: #64748b;
  font-size: 13px;
  margin-bottom: 6px;
  line-height: 1.5;
  font-weight: 500;
}

.contact-phone {
  color: #1e40af;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
}

/* 移动端联系信息 - PC端隐藏 */
.mobile-contact {
  display: none;
}

.qr-code {
  display: inline-block;
  margin-top: 4px;
  max-height: none;
  overflow: visible;
}

.qr-code img {
  display: block;
  border-radius: 10px;
  border: 1px solid rgba(37, 99, 235, 0.16);
  box-shadow: 0 10px 24px rgba(37, 99, 235, 0.1);
  background: #fff;
}

.separator-line {
  height: 1px;
  background: linear-gradient(90deg, rgba(148, 163, 184, 0) 0%, rgba(100, 116, 139, 0.28) 20%, rgba(100, 116, 139, 0.28) 80%, rgba(148, 163, 184, 0) 100%);
  margin: 32px 0 24px;
}

.copyright {
  text-align: center;
}

.copyright-text {
  color: #64748b;
  font-size: 12px;
  line-height: 1.6;
  margin: 0 0 8px;
}

.copyright-links {
  margin: 0;
}

.copyright-links a {
  color: #64748b;
  font-size: 12px;
  text-decoration: none;
  transition: color 0.2s;
}

.copyright-links a:hover {
  color: #1d4ed8;
}

.copyright-links .dot {
  margin: 0 8px;
  color: #94a3b8;
  font-size: 12px;
}

/* Responsive design */
@media (max-width: 1024px) {
  .footer-columns {
    grid-template-columns: repeat(2, 1fr);
    gap: 32px 24px;
  }

  .contact-column {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }
}

@media (max-width: 1023px) {
  .footer {
    padding: 32px 0 0;
  }

  .footer-content {
    padding: 0 15px 24px;
  }

  .footer-columns {
    grid-template-columns: 1fr;
    gap: 0;
    margin-bottom: 24px;
  }

  .footer-column {
    text-align: left;
    border-bottom: 1px solid rgba(148, 163, 184, 0.2);
    position: relative;
    transform: translateZ(0);
    backface-visibility: hidden;
  }

  .footer-column:last-child {
    border-bottom: none;
  }

  .column-title {
    font-size: 15px;
    margin-bottom: 0;
    color: #0f172a;
    padding: 14px 0;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
  }

  .column-title-follow {
    margin-top: 0;
  }

  .column-title::after {
    content: '+';
    font-size: 18px;
    font-weight: 300;
    color: #64748b;
    transition: transform 0.25s ease-out;
    display: inline-block;
  }

  .column-title.accordion-open::after {
    transform: rotate(45deg);
  }

  .column-list {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .column-list.accordion-open {
    max-height: 500px;
    padding-bottom: 14px;
  }

  .column-list li {
    margin-bottom: 10px;
    opacity: 0;
    transform: translateY(-5px);
    transition: opacity 0.2s ease-out, transform 0.2s ease-out;
  }

  .column-list.accordion-open li {
    opacity: 1;
    transform: translateY(0);
  }

  .column-list.accordion-open li:nth-child(1) { transition-delay: 0.05s; }
  .column-list.accordion-open li:nth-child(2) { transition-delay: 0.1s; }
  .column-list.accordion-open li:nth-child(3) { transition-delay: 0.15s; }
  .column-list.accordion-open li:nth-child(4) { transition-delay: 0.2s; }
  .column-list.accordion-open li:nth-child(5) { transition-delay: 0.25s; }
  .column-list.accordion-open li:nth-child(6) { transition-delay: 0.3s; }
  .column-list.accordion-open li:nth-child(7) { transition-delay: 0.35s; }
  .column-list.accordion-open li:nth-child(8) { transition-delay: 0.4s; }

  .column-list a {
    color: #475569;
    font-size: 13px;
    display: block;
    padding: 5px 0;
    -webkit-tap-highlight-color: transparent;
  }

  .column-list a:hover {
    color: #1d4ed8;
  }

  .contact-column {
    grid-column: 1;
    grid-template-columns: 1fr;
    gap: 0;
  }

  .pc-contact {
    margin-bottom: 12px;
  }

  .buy-block {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .buy-block.accordion-open {
    max-height: 220px;
    padding-bottom: 14px;
  }

  .qr-code {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    text-align: left;
  }

  .qr-code.accordion-open {
    max-height: 180px;
    padding-bottom: 14px;
  }

  .qr-code img {
    width: 100px;
    height: 100px;
    display: inline-block;
  }

  .mobile-contact {
    display: block;
    padding: 14px 0;
    margin-bottom: 0;
  }

  .qr-text {
    color: #64748b;
    font-size: 13px;
    margin-bottom: 8px;
  }

  .contact-phone {
    color: #1e40af;
    font-size: 18px;
  }

  .separator-line {
    margin: 24px 0 16px;
  }

  .copyright-text,
  .copyright-links a,
  .copyright-links .dot {
    font-size: 11px;
  }

  .copyright-links .dot {
    margin: 0 6px;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 24px 0 0;
  }

  .footer-content {
    padding: 0 12px 20px;
  }

  .footer-columns {
    margin-bottom: 20px;
  }

  .column-title {
    padding: 12px 0;
  }

  .column-list li {
    margin-bottom: 8px;
  }

  .column-list a {
    font-size: 12px;
  }

  .contact-phone {
    font-size: 16px;
  }

  .qr-code img {
    width: 90px;
    height: 90px;
  }

  .separator-line {
    margin: 20px 0 12px;
  }

  .copyright-text,
  .copyright-links a,
  .copyright-links .dot {
    font-size: 10px;
  }

  .copyright-text {
    margin-bottom: 6px;
  }
}

/* ===== 进入视口动画 ===== */
.footer {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.footer.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* 列交错动画 */
.footer .footer-column {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.5s ease-out, transform 0.5s ease-out;
}

.footer.animate-in .footer-column {
  opacity: 1;
  transform: translateY(0);
}

.footer.animate-in .footer-column:nth-child(1) { transition-delay: 0.1s; }
.footer.animate-in .footer-column:nth-child(2) { transition-delay: 0.2s; }
.footer.animate-in .footer-column:nth-child(3) { transition-delay: 0.3s; }
.footer.animate-in .footer-column:nth-child(4) { transition-delay: 0.4s; }

/* 分隔线动画 */
.footer .separator-line {
  transform: scaleX(0);
  transition: transform 0.6s ease-out;
  transition-delay: 0.5s;
}

.footer.animate-in .separator-line {
  transform: scaleX(1);
}

/* 版权信息动画 */
.footer .copyright {
  opacity: 0;
  transition: opacity 0.4s ease-out;
  transition-delay: 0.7s;
}

.footer.animate-in .copyright {
  opacity: 1;
}

/* 移动端联系信息动画 */
.footer .mobile-contact {
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 0.4s ease-out, transform 0.4s ease-out;
  transition-delay: 0.4s;
}

.footer.animate-in .mobile-contact {
  opacity: 1;
  transform: translateY(0);
}
</style>